export enum ThgQuoteDeadlineStatus {
  open = "open",
  nearDeadline = "nearDeadline",
  closed = "closed",
}
